module.exports = __webpack_public_path__ + "img/attention.15e87b5c.svg";